import generateID from '../reducer/generateID';

export const createOption = (props, domainLogic) => {
  return {
    type: "CREATE_OPTION",
    id: generateID(),
    props,
    domainLogic
  }
}

export const updateOption = (id, props, domainLogic) => {
  return {
    type: "UPDATE_OPTION",
    props,
    id,
    domainLogic
  }
}

export const deleteOption = (id) => {
  return {
    type: "DELETE_OPTION",
    id: id
  }
}
